<template>
  <div class="col-md-12 project-list">
    <div class="card">
      <div class="row">
        <div class="col-10 d-flex align-items-center">
          <div class="input-group me-3" style="max-width: 600px">
            <span class="input-group-text"><i class="fa fa-search"></i></span>
            <input
              class="form-control"
              type="text"
              placeholder="Buscar por título o usuario..."
              v-model="searchQuery"
            />
            <button
              v-if="searchQuery"
              class="btn btn-outline-secondary"
              @click="searchQuery = ''"
              title="Limpiar búsqueda"
            >
              <i class="fa fa-times"></i>
            </button>
          </div>
          <div class="dropdown">
            <button
              class="btn dropdown-toggle"
              type="button"
              data-bs-toggle="dropdown"
              style="width: 150px"
            >
              <i class="fa fa-filter me-1"></i>
              {{ selectedFilter }}
            </button>
            <ul class="dropdown-menu">
              <li v-for="option in filterOptions" :key="option">
                <a
                  href="#"
                  class="dropdown-item"
                  @click.prevent="selectedFilter = option"
                >
                  {{ option }}
                </a>
              </li>
            </ul>
          </div>
        </div>
        <!-- <div
          class="col-2 text-end align-items-center d-flex justify-content-end"
        >
          <button
            class="btn btn-primary"
            type="button"
            @click="openCreateModal"
          >
            Crear Evento
          </button>
        </div> -->
      </div>
    </div>
    <div class="col-sm-12">
      <div class="card">
        <div class="card-body">
          <adminPage :list="filteredEvents" @reload-list="handleEventCreated" />
        </div>
      </div>
    </div>

    <!-- <AdminEventModal
      ref="adminEventModalRef"
      @reloadEvents="handleEventCreated"
    /> -->
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import adminPage from "../projectlist/adminPage.vue";
import AdminEventModal from "../components/AdminEventModal.vue";

const props = defineProps({
  allEvents: {
    type: Array,
    required: true,
  },
});

const adminEventModalRef = ref(null);
const searchQuery = ref("");
const selectedFilter = ref("Todos");
const emit = defineEmits(["reloadList"]);

function openCreateModal() {
  if (adminEventModalRef.value?.showModal) {
    adminEventModalRef.value.showModal();
  }
}

function handleEventCreated() {
  emit("reloadList");
}

const filterOptions = [
  "Todos",
  "Borrador",
  "Enviado",
  "En Revisión",
  "Aprobado",
  "Observado",
  "Rechazado",
];

const statusMap = {
  Borrador: 0,
  Enviado: 1,
  "En Revisión": 2,
  Aprobado: 3,
  Observado: 4,
  Rechazado: 5,
};

onMounted(() => {
  emit("reloadList");
});

const filteredEvents = computed(() => {
  let filtered = props.allEvents.filter((e) => e.state !== 3);

  if (selectedFilter.value !== "Todos") {
    filtered = filtered.filter(
      (e) => e.inbox === statusMap[selectedFilter.value]
    );
  }

  if (searchQuery.value.trim()) {
    const q = searchQuery.value.toLowerCase();
    filtered = filtered.filter((e) => {
      const userName = `${e.user?.name ?? ""} ${
        e.user?.first_last_name ?? ""
      } ${e.user?.second_last_name ?? ""}`;
      return (
        e.title.toLowerCase().includes(q) || userName.toLowerCase().includes(q)
      );
    });
  }

  return filtered;
});
</script>
